import { AsyncPipe, NgFor, NgIf } from "@angular/common";
import { ChangeDetectionStrategy, Component } from "@angular/core";
import { FieldsetModule } from "primeng-v17/fieldset";
import { TranslateDirective } from "../../shared/transloco/translate.directive";
import { FormlyCertifiedEducationExamsEntryComponent } from "./formly-certified-education-exams-entry.component";
import { NewUiFormlyCertifiedEducationExamsComponent } from "./new-ui-formly-certified-education-exams.component";

@Component({
  selector: "app-formly-certified-education-exams",
  templateUrl: "./formly-certified-education-exams.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslateDirective, NgIf, FieldsetModule, NgFor, FormlyCertifiedEducationExamsEntryComponent, AsyncPipe],
})
export class FormlyCertifiedEducationExamsComponent extends NewUiFormlyCertifiedEducationExamsComponent {}
